module.exports = __webpack_public_path__ + "img/sc-3p-2024.eb3adc30.png";